import { render, staticRenderFns } from "./InvitesDetail.vue?vue&type=template&id=7b25cc79"
import script from "./InvitesDetail.vue?vue&type=script&lang=js"
export * from "./InvitesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports